// extracted by mini-css-extract-plugin
module.exports = {"treebankContainer":"Treebank_treebankContainer__sQn_K","text":"Treebank_text__38CzO","graph":"Treebank_graph__1l6uy"};